import React from 'react';
import PageShell from '../../components/PageShell';
import { Eyebrow, SectionHeading, InfoCard, GradientButton, ContextStrip } from '../../components/common/Primitives';
import { PROJECT_OVERVIEW } from '../../lib/mock2';

export default function ProjectOverview() {
  return (
    <PageShell>
      <section className="px-6 pt-12 pb-8">
        <div className="mx-auto max-w-[1240px]">
          <Eyebrow color="purple">MEDIA RESOURCE</Eyebrow>
          <div className="mt-3 grid grid-cols-1 gap-10 lg:grid-cols-[1.2fr_1fr]">
            <div>
              <h1 className="text-[42px] md:text-[52px] font-extrabold leading-[1.06] tracking-tight text-navy">{PROJECT_OVERVIEW.hero.title}</h1>
              <p className="mt-5 max-w-xl text-[15.5px] leading-relaxed text-ink-500">{PROJECT_OVERVIEW.hero.desc}</p>
              <div className="mt-6 flex flex-wrap gap-3">
                <GradientButton>Download One-Page Overview</GradientButton>
                <GradientButton to="/school" variant="outline">Explore the School Experience</GradientButton>
              </div>
            </div>
            <div className="rounded-3xl bg-gradient-to-br from-purple via-royal to-mint grain grid place-items-center text-white text-[13px] font-bold aspect-video shadow-card">PROJECT OVERVIEW INFOGRAPHIC</div>
          </div>
        </div>
      </section>

      <section className="px-6 py-16">
        <div className="mx-auto max-w-[1240px]">
          <SectionHeading eyebrow="WHAT IT IS" title="One connected learning ecosystem" desc="Gyan Dhara combines immersive VR learning, AI-powered assessment, multilingual guidance and actionable school analytics." />
          <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-3">
            {PROJECT_OVERVIEW.ecosystem.map((e,i)=>(<InfoCard key={i} letter={e.letter} color={e.color} title={e.title} desc={e.desc} />))}
          </div>
        </div>
      </section>

      <section className="px-6 py-16 bg-white">
        <div className="mx-auto max-w-[1240px]">
          <SectionHeading eyebrow="WHO IT SERVES" title="Audience pathways" desc="Each audience sees a relevant experience while retaining access to the full website." />
          <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-4">
            {PROJECT_OVERVIEW.audiences.map((a,i)=>(<InfoCard key={i} letter={a.letter} color={a.color} title={a.title} desc={a.desc} />))}
          </div>
        </div>
      </section>

      <section className="px-6 py-16 pb-24">
        <div className="mx-auto max-w-[1240px]">
          <SectionHeading eyebrow="CURRENT SCOPE" title="Available for institutional deployment" desc="The school experience is focused on NCERT-aligned Grade 8 and 9 Science and Mathematics, alongside exploratory applications." />
          <div className="mt-8"><ContextStrip items={[{ k: 'GRADES', v: '8 and 9' }, { k: 'SUBJECTS', v: 'Science and Mathematics' }, { k: 'LANGUAGES', v: 'English, Hindi and Assamese' }, { k: 'CORE OPERATION', v: 'Offline-first' }, { k: 'MINIMUM SETUP', v: 'Three Quest 3S headsets' }]} /></div>
        </div>
      </section>
    </PageShell>
  );
}
